import React, { Component } from 'react';
import { isEmpty, get, cloneDeep } from 'lodash';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import routes from '../../../../routes';

import {
    getOptimizerListAction,
    getOptimizerListRecommendationAction
} from '../../../../actions';

import { isApiCallSuccess } from '../../../../selectors';

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPlatformManager: '',
            acceptModal: false,
            rejectModal: false,
            viewRecommendModal: false,
            selectedRecommendation: null,
            keywordRecommendationData: [],
            creativeRecommendationsData: []
        };
    }

    async componentWillMount() {

        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
        const { history, getPaymentRelatedAccessAction, tenantId, userId, authToken } = this.props;
        if (isEmpty(isAuthenticated)) {
            history.push(routes.preSignIn);
        }
        const dataLocal = JSON.parse(localStorage.getItem("PreSignInData"))
        let Isplat = dataLocal.responseList[0].tenantType
        this.setState({ isPlatformManager: Isplat })

        if (Isplat == "Platform Manager") {
            this.setState({ showSpinner: false })
        } else {
            // await this.getListData();
            this.setState({ showSpinner: false })
        }
    }

    // getListData = async () => {

    //     try {
    //         const { tenantId, authToken, userId, getRecoTypeSubTypeAction, location } = this.props;
    //         const optimizerTypes = location.state;
    //         console.log('optimizerTypes:', optimizerTypes);

    //         let payload = {
    //             type: optimizerTypes.type,
    //             subType: optimizerTypes.subType,
    //             // advId : IN CASE OF AGENCY
    //         };

    //         const {
    //             responseCode: { status = "" },
    //             response,
    //         } = await getRecoTypeSubTypeAction({ tenantId, authToken, userId, payload });

    //         if (isApiCallSuccess(status)) {
    //             console.log("response", response);

    //             let keywordRecommendations = [];
    //             let creativeRecommendations = [];

    //             response.forEach(recoType => {
    //                 Object.keys(recoType).forEach(recoTypeName => {
    //                     console.log("recoType[recoTypeName]", recoType[recoTypeName]);

    //                     if (typeof recoType[recoTypeName] == 'object') {
    //                         if (recoTypeName == 'generativeAI') {
    //                             if (recoType[recoTypeName].creativeReco) {
    //                                 creativeRecommendations.push(...recoType[recoTypeName].creativeReco);
    //                             }
    //                             if (recoType[recoTypeName].keywordReco) {
    //                                 keywordRecommendations.push(...recoType[recoTypeName].keywordReco);
    //                             }
    //                         }
    //                     } else {
    //                         console.log("recoType[recoTypeName] is not an array or object");
    //                     }
    //                 });
    //             });

    //             keywordRecommendations = keywordRecommendations.map(recommendation => ({
    //                 ...recommendation,
    //                 type: "Keyword"
    //             }));

    //             creativeRecommendations = creativeRecommendations.map(recommendation => ({
    //                 ...recommendation,
    //                 type: "Creative"
    //             }));

    //             this.setState({
    //                 keywordRecommendationData: keywordRecommendations,
    //                 creativeRecommendationData: creativeRecommendations
    //             })

    //             // You can do further processing or set state here if needed
    //         } else {
    //             this.setState({ showSpinner: false });
    //         }
    //     } catch (err) {
    //         // Handle errors
    //         console.error(err);
    //         this.setState({ showSpinner: false });
    //     }
    // }

    render() {
        const { section, handleTotalSectionClick, handleSubsectionClick } = this.props;
        // console.log("this.props", this.props)
        return (
            <div key={section.id} className='col-12 bg-white border rounded-3 mx-2 mt-3 mb-2 p-2 px-3'>
                <div className='d-flex align-items-center'>
                    <h4 className='mb-0 mr-1' style={{ fontWeight: 500 }}>{section.title == "Generative" ? "Generative AI " : section.title}</h4>
                    <p style={{ color: "#707B8A", fontSize: 13 }}>{section.description}</p>
                </div>
                <div className='d-flex col-2 px-0 align-items-center mb-2' style={{ fontSize: 12, cursor: "pointer" }} onClick={() => handleTotalSectionClick(section)}>
                    Total Campaigns: &nbsp;<strong style={{ color: "#303890", fontSize: 16 }}> {section.totalCampaigns}</strong>
                </div>
                <div className='d-flex align-items-center mx-n3 px-0 pt-2' style={{ borderTop: "1px solid #C4CCD8", fontSize: 12 }}>
                    <div className='col-2 d-flex px-0'>
                        {section.subsections.map((subsection, subIndex) => (
                            <div key={subIndex} style={{ cursor: "pointer" }} onClick={() => handleSubsectionClick(section, subsection)} className={`col-${section.title == "Optimiser" ? '8' : section.title == "BidControl" ? '7' : '6'} pl-3`}>
                                {subsection.title}: <strong style={{ color: "#303890", fontSize: 14 }}>{subsection.value}</strong>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(connect(
    state => ({
        tenantId: get(state, 'app.preSignInState.tenantId', ''),
        userId: get(state, 'app.preSignInData.userId', ''),
        authToken: get(state, 'app.signInData.authToken', '')
    }),
    {
        getOptimizerListAction,
        getOptimizerListRecommendationAction
    }
)(index));

// ----*  IO propTypes * ----
index.propTypes = {
    configurationList: PropTypes.array,
    tenantId: PropTypes.number,
    userId: PropTypes.number,
    authToken: PropTypes.string,
};